import bagongPilipinasLogo from '@/assets/BAGONG-PILIPINAS-LOGO.png';
import denrLogo from '@/assets/denr-logo.png';
import { format } from 'date-fns';

const PLTCPPrintTemplatePage1 = ({ certificate, certificateData, orderOfPayment }) => {
   const formatDate = (timestamp) => {
      if (!timestamp) return null;
      try {
         return format(new Date(parseInt(timestamp)), 'MMMM d, yyyy');
      } catch (error) {
         console.error('Error formatting date:', error);
         return null;
      }
   };

   // Early return if no certificate data
   if (!certificate || !certificate.pltcpCertificateData) {
      console.error('Missing certificate data:', certificate);
      return null;
   }

   const {
      certificateNumber,
      dateIssued,
      expiryDate,
      pltcpCertificateData
   } = certificate;

   const {
      name,
      occupation,
      projectLocation,
      projectAddress,
      purpose,
      treeInventory,
      totalTrees,
      totalGrossVolume,
      totalNetVolume
   } = pltcpCertificateData;

   const numberToWords = (num) => {
      if (num === undefined || num === null) return '';

      const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten',
         'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
      const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

      if (num < 20) return ones[num];

      if (num < 100) {
         return tens[Math.floor(num / 10)] + (num % 10 ? '-' + ones[num % 10] : '');
      }

      if (num < 1000) {
         return ones[Math.floor(num / 100)] + ' hundred' + (num % 100 ? ' ' + numberToWords(num % 100) : '');
      }

      return num.toString();
   };

   // Format total trees with number to words
   const totalTreesInWords = totalTrees ?
      `${numberToWords(totalTrees).toUpperCase()} (${totalTrees}) ${treeInventory?.[0]?.species || ''} trees` :
      '_______';

   return `
    <style>
      @page {
        size: A4;
        margin: 15mm;
      }
      body {
        font-family: Times New Roman, serif;
        color: #000;
        background: #fff;
        line-height: 1.5;
        font-size: 12pt;
        margin: 0;
        padding: 0;
        height: 100%;
        overflow: hidden !important;
        -ms-overflow-style: none !important; /* IE and Edge */
        scrollbar-width: none !important; /* Firefox */
      }
      body::-webkit-scrollbar {
        display: none !important; /* Chrome, Safari, Opera */
      }
      .no-print {
        display: none !important;
      }
      .wrapper {
        max-width: 21cm;
        margin: 0 auto;
        overflow: hidden !important;
        height: 100%;
        position: relative;
      }
      .header {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
      }
      .logo-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-bottom: 0.25rem;
      }
      .logo {
        height: 65px;
        width: auto;
      }
      .header-text {
        text-align: center;
        font-size: 10pt;
        margin: 0;
        line-height: 1.2;
      }
      .title {
        font-size: 14pt;
        font-weight: bold;
        margin: 1rem 0 0.5rem;
        text-align: center;
      }
      .cert-number {
        text-align: center;
        margin-bottom: 1rem;
      }
      .content-block {
        margin-bottom: 1rem;
        text-align: justify;
      }
      .blue-text {
        color: #0000ff;
        font-weight: bold;
      }
      .center-text {
        text-align: center;
      }
      .list-decimal {
        padding-left: 20px;
        margin: 0.5rem 0;
      }
      .list-decimal li {
        margin-bottom: 0.5rem;
        text-align: justify;
      }
      table {
        width: 100%;
        border-collapse: collapse;
        margin: 0.5rem 0 1rem;
      }
      table th, table td {
        border: 1px solid black;
        padding: 4px;
        text-align: center;
      }

      /* Hide all scrollbars */
      * {
        scrollbar-width: none !important;
        -ms-overflow-style: none !important;
      }
      *::-webkit-scrollbar {
        display: none !important;
      }
      html, .print-page {
        overflow: hidden !important;
      }
    </style>

    <div class="wrapper">
      <div class="header">
        <div class="logo-container">
          <img src="${denrLogo}" alt="DENR Logo" class="logo" />
          <img src="${bagongPilipinasLogo}" alt="Bagong Pilipinas Logo" class="logo" />
        </div>

        <div>
          <p class="header-text">DEPARTMENT OF ENVIRONMENT AND NATURAL RESOURCES</p>
          <p class="header-text">KAGAWARAN NG KAPALIGIRAN AT LIKAS NA YAMAN</p>
          <p class="header-text">PENRO MARINDUQUE</p>
        </div>
      </div>

      <p class="title">TREE CUTTING PERMIT</p>
      <p class="cert-number">NO. DENR PENRO MARINDUQUE-${certificateNumber ? certificateNumber.split('-').pop() : '0024'}</p>

      <div class="content-block">
        Pursuant to P.D. 705, as amended, DAO 2021-11, and existing forestry laws, rules, and regulations, a
        Tree Cutting Permit is hereby granted to:
      </div>

      <div class="center-text">
        <p class="blue-text">DEPARTMENT OF EDUCATION</p>
        <p class="blue-text">MIMAROPA REGION</p>
        <p class="blue-text">SCHOOLS DIVISION OF MARINDUQUE</p>
        <p class="blue-text">
          REPRESENTED BY ${name || 'Mark Gilbert Reginio'}, ${occupation || 'Software Developer'}, ${projectLocation || 'Tanza, Boac, Marinduque'}
        </p>
      </div>

      <div class="center-text">
        <p>For the Purpose of</p>
        <p class="blue-text">${purpose || 'test'}</p>
      </div>

      <div class="center-text">
        <p>located in</p>
        <p class="blue-text">${projectAddress || 'Tanza, Boac, Marinduque'}</p>
      </div>

      <div class="content-block">
        <p>Subject to the following conditions:</p>
        <ol class="list-decimal">
          <li>
            The trees requested for removal shall be incorporated in the design of the project to be
            rehabilitated/reconstructed, to the extent possible, to minimize loss of trees;
          </li>
          <li>
            A total of <u>TWO (2) Mango trees</u>, as verified by PENRO Technical Personnel shall be authorized to be cut which is
            shown in the table below.
          </li>
        </ol>
      </div>

      <div>
        <p style="font-weight: bold;">Table 1. Trees authorized to be cut:</p>
        <table>
          <thead>
            <tr>
              <th>Name of Species</th>
              <th>No. of Trees Inventoried</th>
              <th>Gross Volume (cu.m)</th>
              <th>Net Volume (cu.m)</th>
              <th>Tree Category</th>
            </tr>
          </thead>
          <tbody>
            ${treeInventory?.map((tree, index) => `
              <tr>
                <td>Mango<br/>(${tree.scientificName || 'Mangifera'})</td>
                <td>${tree.numberOfTreesInventoried || 2}</td>
                <td>${tree.grossVolume?.toFixed(3) || '1.100'}</td>
                <td>${tree.netVolume?.toFixed(3) || '1.200'}</td>
                <td>${tree.treeCategory || 'Planted'}</td>
              </tr>
            `).join('') || `
              <tr>
                <td>Mango<br/>(Mangifera)</td>
                <td>2</td>
                <td>1.100</td>
                <td>1.200</td>
                <td>Planted</td>
              </tr>
            `}
            <tr>
              <td style="font-weight: bold;">Grand Total</td>
              <td>${totalTrees || 2}</td>
              <td>${totalGrossVolume?.toFixed(3) || '1.100'}</td>
              <td>${totalNetVolume?.toFixed(3) || '1.200'}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <ol class="list-decimal" start="3">
          <li>
            Issues that will arise from the tree cutting should be addressed directly by the permittee;
          </li>
          <li>
            Prior to tree cutting operations, a placard or signboard measuring 4' x 8' shall be installed within the
            cutting area informing the public that the tree cutting operation is authorized by the DENR and indicating
            the name of the permittee, the purpose of tree cutting and the number of trees to be cut;
          </li>
          <li>
            The tree cutting operations shall, at all times, be under the direct supervision of the PENRO
            Marinduque, or her duly authorized representative(s);
          </li>
          <li>
            The permittee shall be required to replace each tree to be cut with fifty (50) seedlings of indigenous species;
          </li>
        </ol>
      </div>

      <div style="text-align: center; position: fixed; bottom: 20px; width: 100%; font-size: 8pt; line-height: 1.6;">
        <div>Capitol Compound, Barangay Bangbangalon, Boac, Marinduque</div>
        <div>Telephone Nos.: (042) 332-0626 / Telefax No.: (042) 332-1885</div>
        <div>Website: https://penromarinduque.gov.ph/ • Email: penromarinduque@gmail.com</div>
      </div>
    </div>
  `;
};

const PLTCPPrintTemplatePage2 = ({ certificate, certificateData, orderOfPayment }) => {
   const formatDate = (timestamp) => {
      if (!timestamp) return null;
      try {
         return format(new Date(parseInt(timestamp)), 'MMMM d, yyyy');
      } catch (error) {
         console.error('Error formatting date:', error);
         return null;
      }
   };

   // Early return if no certificate data
   if (!certificate || !certificate.pltcpCertificateData) {
      console.error('Missing certificate data:', certificate);
      return null;
   }

   const {
      certificateNumber,
      dateIssued,
      expiryDate
   } = certificate;

   return `
    <style>
      @page {
        size: A4;
        margin: 15mm;
      }
      body {
        font-family: Times New Roman, serif;
        color: #000;
        background: #fff;
        line-height: 1.5;
        font-size: 12pt;
        margin: 0;
        padding: 0;
        height: 100%;
        overflow: hidden !important;
        -ms-overflow-style: none !important; /* IE and Edge */
        scrollbar-width: none !important; /* Firefox */
      }
      body::-webkit-scrollbar {
        display: none !important; /* Chrome, Safari, Opera */
      }
      .no-print {
        display: none !important;
      }
      .wrapper {
        max-width: 21cm;
        margin: 0 auto;
        overflow: hidden !important;
        height: 100%;
        position: relative;
      }
      .header {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
      }
      .logo-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-bottom: 0.25rem;
      }
      .logo {
        height: 65px;
        width: auto;
      }
      .header-text {
        text-align: center;
        font-size: 10pt;
        margin: 0;
        line-height: 1.2;
      }
      .title {
        font-size: 14pt;
        font-weight: bold;
        margin: 1rem 0 0.5rem;
        text-align: center;
      }
      .cert-number {
        text-align: center;
        margin-bottom: 1rem;
      }
      .content-block {
        margin-bottom: 1rem;
        text-align: justify;
      }
      .list-decimal {
        padding-left: 20px;
        margin: 0.5rem 0;
      }
      .list-decimal li {
        margin-bottom: 0.5rem;
        text-align: justify;
      }
      .signature-section {
        margin-top: 60px;
        text-align: center;
      }
      .signature-line {
        width: 200px;
        margin: 0 auto;
        border-top: 1px solid black;
        padding-top: 5px;
      }

      /* Hide all scrollbars */
      * {
        scrollbar-width: none !important;
        -ms-overflow-style: none !important;
      }
      *::-webkit-scrollbar {
        display: none !important;
      }
      html, .print-page {
        overflow: hidden !important;
      }
    </style>

    <div class="wrapper">
      <div class="header">
        <div class="logo-container">
          <img src="${denrLogo}" alt="DENR Logo" class="logo" />
          <img src="${bagongPilipinasLogo}" alt="Bagong Pilipinas Logo" class="logo" />
        </div>

        <div>
          <p class="header-text">DEPARTMENT OF ENVIRONMENT AND NATURAL RESOURCES</p>
          <p class="header-text">KAGAWARAN NG KAPALIGIRAN AT LIKAS NA YAMAN</p>
          <p class="header-text">PENRO MARINDUQUE</p>
        </div>
      </div>

      <p class="title">TREE CUTTING PERMIT</p>
      <p class="cert-number">NO. DENR PENRO MARINDUQUE-${certificateNumber ? certificateNumber.split('-').pop() : '0024'}</p>

      <div>
        <ol class="list-decimal" start="7">
          <li>
            The permittee shall be required to undertake measures during and after tree cutting operations to mitigate
            the possible impacts of the said activity to the locality and the environment; and
          </li>
          <li>
            <strong>
              Violation of any of the terms and conditions of the permit issued shall be sufficient ground for
              the termination/cancellation of this permit
            </strong>, subject to due process without prejudice to the imposition
            of appropriate penalties pursuant to existing regulations, and one strike policy to concerned DENR official(s)
            and/or personnel.
          </li>
        </ol>
      </div>

      <div class="content-block">
        <p>
          This permit is effective <strong>Fifty (50) days</strong> upon receipt hereof or as soon as the authorized number of trees
          had already been cut, whichever comes first.
        </p>
      </div>

      <div class="content-block">
        <p>
          Issued this ${formatDate(dateIssued) || '________________'}, 2024, at DENR PENRO Marinduque, Capitol Compound, Brgy. Bangbangalon,
          Boac, Marinduque.
        </p>
      </div>

      <div class="content-block">
        <p>By the Authority of the Secretary:</p>
        <div class="signature-section">
          ${certificate.penrCenrOfficerSignature?.data ?
            `<img src="data:${certificate.penrCenrOfficerSignature.contentType};base64,${certificate.penrCenrOfficerSignature.data}"
                alt="PENR Officer Signature"
                style="max-height: 60px; margin: 0 auto; display: block;">`
            : ''
          }
          <div class="signature-line">
            <p style="margin: 0; font-weight: bold;">IMELDA M. DIAZ</p>
            <p style="margin: 0;">OIC, PENR Officer</p>
          </div>
        </div>
      </div>

      <div style="text-align: center; margin-top: 40px;">
        <p>***Not valid without DENR PENRO Marinduque Official Dry Seal***</p>
      </div>

      <div style="text-align: center; position: fixed; bottom: 20px; width: 100%; font-size: 8pt; line-height: 1.6;">
        <div>Capitol Compound, Barangay Bangbangalon, Boac, Marinduque</div>
        <div>Telephone Nos.: (042) 332-0626 / Telefax No.: (042) 332-1885</div>
        <div>Website: https://penromarinduque.gov.ph/ • Email: penromarinduque@gmail.com</div>
      </div>
    </div>
  `;
};

export { PLTCPPrintTemplatePage1, PLTCPPrintTemplatePage2 };

